import React from "react";

function formatCurrency(value) {
  if (value === null || value === undefined) return "–";
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatDate(dateStr) {
  if (!dateStr) return "–";
  // Truncates the time component from "2026-03-17T00:00:00"
  return dateStr.split("T")[0];
}

export default function SalesDetailTable({
  detailedData = [],
  context = null,
  onClose,
}) {
  console.log("detailedData SalesDetailTable", detailedData);

  if (!detailedData || detailedData.length === 0) {
    return (
      <div
        style={{
          padding: 2,
          border: "1px dashed #D1D5DB",
          borderRadius: 8,
          color: "#6B7280",
          marginTop: 20,
        }}
      >
        No detailed transaction records found for this period.
      </div>
    );
  }

  const totalAmount = detailedData.reduce(
    (sum, item) => sum + (item.AMOUNT || 0),
    0
  );
  const totalVat = detailedData.reduce(
    (sum, item) => sum + (item.VATAMT || 0),
    0
  );

  return (
    <div
      style={{
        fontFamily: "sans-serif",
        border: "1px solid #E5E7EB",
        borderRadius: 8,
        padding: 2,
        background: "#fff",
      }}
    >
      {/* Header section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
       
      </div>

      {/* Table responsive container */}
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 13,
            textAlign: "left",
          }}
        >
          <thead>
            <tr
              style={{
                background: "#F9FAFB",
                borderBottom: "1px solid #E5E7EB",
              }}
            >
              {/* <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                }}
              >
                Inv No
              </th> */}
              <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                }}
              >
                Date
              </th>
              <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                }}
              >
                Customer
              </th>
              <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                }}
              >
                Type
              </th>
              <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                  textAlign: "right",
                }}
              >
                VAT Amount
              </th>
              <th
                style={{
                  padding: "10px 12px",
                  color: "#4B5563",
                  fontWeight: 600,
                  textAlign: "right",
                }}
              >
                Amount
              </th>
            </tr>
          </thead>
          <tbody>
            {detailedData.map((item, index) => (
              <tr
                key={item["INV NO"] || index}
                style={{
                  borderBottom: "1px solid #F3F4F6",
                  verticalAlign: "middle",
                }}
              >
              
                <td style={{ padding: "10px 12px", color: "#4B5563" }}>
                  {formatDate(item["INV DATE"])}
                </td>
                <td
                  style={{
                    padding: "10px 12px",
                    color: "#1F2937",
                    maxWidth: 260,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={item.CUSTOMER}
                >
                  {item.CUSTOMER}
                </td>
                <td style={{ padding: "10px 12px", color: "#6B7280" }}>
                  <span
                    style={{
                      background: item.CASHCRED === "R" ? "#FEF3C7" : "#E0F2FE",
                      color: item.CASHCRED === "R" ? "#92400E" : "#0369A1",
                      padding: "2px 6px",
                      borderRadius: 4,
                      fontSize: 11,
                      fontWeight: 500,
                    }}
                  >
                    {item.CASHCRED === "R"
                      ? "Credit"
                      : item.CASHCRED || "Other"}
                  </span>
                </td>
                <td
                  style={{
                    padding: "10px 12px",
                    textAlign: "right",
                    color: "#4B5563",
                  }}
                >
                  {formatCurrency(item.VATAMT)}
                </td>
                <td
                  style={{
                    padding: "10px 12px",
                    textAlign: "right",
                    fontWeight: 500,
                    color: "#111827",
                  }}
                >
                  {formatCurrency(item.AMOUNT)}
                </td>
              </tr>
            ))}

            {/* Summary Row */}
            <tr
              style={{
                background: "#F9FAFB",
                fontWeight: 600,
                borderTop: "2px solid #E5E7EB",
              }}
            >
              <td
                colSpan="3"
                style={{
                  padding: "12px",
                  textAlign: "right",
                  color: "#374151",
                }}
              >
                Total:
              </td>
              <td
                style={{
                  padding: "12px",
                  textAlign: "right",
                  color: "#374151",
                }}
              >
                {formatCurrency(totalVat)}
              </td>
              <td
                style={{
                  padding: "12px",
                  textAlign: "right",
                  color: "#0C447C",
                  fontSize: 14,
                }}
              >
                {formatCurrency(totalAmount)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
